import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className={scrolled ? 'scrolled' : ''}>
      <div className="logo-container">
        <Link to="/">
          <img src="/images/logo-circular.png" alt="Grounded Coffee Co. Logo" className="logo" />
        </Link>
      </div>
      <nav>
        <ul className="nav-links" style={{ display: mobileMenuOpen ? 'flex' : '' }}>
          <li><Link to="/" className={isActive('/')} onClick={handleLinkClick}>Menu</Link></li>
          <li><Link to="/about" className={isActive('/about')} onClick={handleLinkClick}>About Us</Link></li>
          <li><Link to="/location" className={isActive('/location')} onClick={handleLinkClick}>Find Us</Link></li>
          <li><Link to="/loyalty" className={isActive('/loyalty')} onClick={handleLinkClick}>Loyalty Program</Link></li>
        </ul>
        <div className="mobile-menu" onClick={toggleMobileMenu}>
          <i className={mobileMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
        </div>
      </nav>
      {mobileMenuOpen && (
        <div className={`mobile-menu-overlay ${mobileMenuOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li><Link to="/" className={isActive('/')} onClick={handleLinkClick}>Menu</Link></li>
            <li><Link to="/about" className={isActive('/about')} onClick={handleLinkClick}>About Us</Link></li>
            <li><Link to="/location" className={isActive('/location')} onClick={handleLinkClick}>Find Us</Link></li>
            <li><Link to="/loyalty" className={isActive('/loyalty')} onClick={handleLinkClick}>Loyalty Program</Link></li>
          </ul>
        </div>
      )}
    </header>
  );
}

export default Header;

